var map = {
	"./aeponyx.png": 473,
	"./ciena.png": 353,
	"./headshot.png": 197,
	"./intuit-turbotax.jpg": 56,
	"./intuit-turbotax.svg": 756,
	"./long_logo.png": 215,
	"./long_logo_pink.png": 144,
	"./sap-concur.png": 844,
	"./tbs.png": 482,
	"./uottawa.png": 734
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 907;